<template>
  <div class="overflow-x-hidden">
    <div class="max-w-screen-xl mx-auto mt-10 md:mt-12 lg:mt-16 xl:mt-20">
      <div class="grid items-center gap-8 md:grid-cols-2">
        <div
          class="px-4 pt-16 text-center md:text-left py-5 justify-self-center"
        >
          <div
            class="flex flex-col gap-4 mb-10"
            v-for="customization in customizations"
          >
            <h2 class="text-xl md:text-2xl lg:text-3xl font-medium">
              {{ customization.title }}
            </h2>
            <div class="text-lg">
              {{ customization.description }}
            </div>
          </div>
        </div>
        <div class="p-4 relative md:ml-10 mx-auto">
          <div class="full-block">
            <nuxt-img loading="lazy"
              src="/page-builder.png"
              alt="qr-code-page-builder"
              format="webp"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import QrContentLocale from "~~/config/widgets/qr-content";

const customizations = new QrContentLocale().data;
</script>
<style>
@media (min-width: 768px) {
  .full-block {
    margin: 0 -100% 0 -10%;
  }
}
</style>
